import axios from "axios";
import {loggedOut} from "../auth";
import LocalStorage from "../../localStorage";
const localStorageService = LocalStorage.getService();


export const GET_DOWNLOAD_DMG_REQUEST = 'GET_DOWNLOAD_DMG_REQUEST';
export const GET_DOWNLOAD_DMG_SUCCESS = 'GET_DOWNLOAD_DMG_SUCCESS';
export const GET_DOWNLOAD_DMG_FAILURE = 'GET_DOWNLOAD_DMG_FAILURE';

export const getDownloadDmgRequest = () => {
    return {type: GET_DOWNLOAD_DMG_REQUEST}
}

export const getDownloadDmgSuccess = (downloadUrl) => {
    return {type: GET_DOWNLOAD_DMG_SUCCESS, downloadUrl}
}

export const getDownloadDmgFailure = (error) => {
    return {type: GET_DOWNLOAD_DMG_FAILURE, error}
}

export const startGetDownloadDmg = () => {
    console.log('Start startGetDownloadDmg');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getDownloadDmgRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/dmgPharmDownload?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response download url ", response.data);
                    dispatch(getDownloadDmgSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if (error.response.status === 401) dispatch(loggedOut());
                dispatch(getDownloadDmgFailure(error));
            });
    };
};
